import React from 'react';
import './Testimonials.css';

const testimonials = [
  {
    name: 'Fortune Quarshie',
    title: 'Lead, Digital Banking Analytics · Access Bank',
    avatarSrc: '/fortune.png',
    quote:
      'Emmanuel brought clarity and structure to a project that was already behind schedule. His project management approach was calm, methodical, and results-driven. Within weeks, timelines were stabilized, risks were clearly managed, and delivery was back on track. I would confidently recommend him to any organization needing reliable project leadership.',
  },
  {
    name: 'Jesse Afari',
    title: 'Senior Data Scientist · MPS Ghana',
    avatarSrc: '/jesse.jpg',
    quote:
      'Working with Emmanuel was a game changer for our delivery process. His Agile and Scrum expertise helped the team collaborate better and ship on time. Beyond project management, his understanding of IT systems made communication between technical and business teams seamless. A true professional who delivers real value.',
  },
  {
    name: 'Stephen Donkor',
    title: 'IT & Infrastructure Consultant · Assets Circle Network',
    avatarSrc: '/stephen.jpg',
    quote:
      'Emmanuel has a rare combination of strong project management skills and hands-on IT expertise. He resolved critical system issues quickly while putting long-term service management processes in place. His ITIL-based approach significantly reduced incidents and improved system stability. Highly dependable and solution-oriented.',
  },
];

function initials(name) {
  return name
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map((p) => p[0].toUpperCase())
    .join('');
}

export default function Testimonials() {
  return (
    <section className="section testimonials anchor" id="testimonials">
      <div className="container">
        <header className="testimonials__header">
          <h2 className="testimonials__title">What Clients Say</h2>
          <p className="testimonials__subtitle">
            Real outcomes from real teams - delayed projects rescued, incidents eliminated, and
            delivery brought back under control.
          </p>
        </header>

        <div className="testimonials__grid">
          {testimonials.map((t) => (
            <figure className="testimonials__card" key={t.name}>
              <div className="testimonials__top">
                <div className="testimonials__avatar" aria-hidden>
                  {t.avatarSrc ? (
                    <img
                      className="testimonials__avatarImg"
                      src={t.avatarSrc}
                      alt=""
                      loading="lazy"
                    />
                  ) : (
                    <span className="testimonials__avatarText">{initials(t.name)}</span>
                  )}
                </div>
                <figcaption className="testimonials__meta">
                  <div className="testimonials__name">{t.name}</div>
                  <div className="testimonials__titleText">{t.title}</div>
                </figcaption>
              </div>
              <blockquote className="testimonials__quote">“{t.quote}”</blockquote>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
